import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceFlowStatus } from 'src/app/_enums/insurance-flow/insurance-flow-status.enum';
import { PolicyStatus } from 'src/app/_enums/proposal.enums';
import { UpdatePolicyStatusModal } from 'src/app/shared/components/policy-status-update-modal/policy-status-update-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-archive-policy-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    UpdatePolicyStatusModal,
    IconsModule,
  ],
  templateUrl: './archive-policy.component.html',
})
export class ArchivePolicyStepperActionComponent extends BaseStepperAction {
  @ViewChild('statusModal') statusModal: UpdatePolicyStatusModal;

  get policy() {
    return this.state?.policy;
  }

  get enabled() {
    const status = this.state.insuranceFlowData?.status;
    return (
      status === InsuranceFlowStatus.PENDING_ACTIVATION ||
      status === InsuranceFlowStatus.POLICY_ACTIVE ||
      status === InsuranceFlowStatus.POLICY_SUSPENDED ||
      status === InsuranceFlowStatus.POLICY_CANCELLED
    );
  }

  PolicyStatus = PolicyStatus;
}
